import {Credentials} from "@app/core/credentials/domain/credentials";
import {UpdateCredentialsData} from "@app/core/credentials/domain/update-credentials-data";

export abstract class CredentialsStorage {

    public abstract save(credentials: Credentials): Promise<void>;
    public abstract getCredentials(): Promise<Credentials | null>;
    public abstract getTemporalCredentials(): Credentials | null;
    public abstract update(updateCredentialsData: UpdateCredentialsData): Promise<void>;
    /**
     * It saves the user and the password in the storage temporarily.
     * The temporal credentials will be deleted when the user logged in or when the app is closed.
     * @param credentials
     */
    public abstract saveTemporalCredentials(credentials: Credentials): void;
    public abstract deleteCredentials(): Promise<void>;
}
